
import React, { useEffect, useState } from 'react'
import { Card, Row, Col, Form, Button, Modal, Badge } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import ControlContrasenasService from '../../../Services/Catalogos/CatSistemas'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import { EmpleadoMasterDto } from './DTO/EmpleadoMasterDto'
import { ControlContrasena } from './DTO/DTOControlContrasena'
import { ActualizarContrasenaDto } from './DTO/DTOActualizarContrasena'
import ReporteControlContrasenas from './ReporteControlContrasenas';
import { CatTipoContrasenaDto } from './DTO/DTOCatTipoContrasena'


interface Props {
    numEmpleadoInicial?: string; // Para que cargue directo si viene del otro catálogo
} 


// const ControlContrasenas: React.FC = () => {

const ControlContrasenas: React.FC<Props> = ({ numEmpleadoInicial }) => {

    const [empleados, setEmpleados] = useState<EmpleadoMasterDto[]>([])
    const [empleadosFiltrados, setEmpleadosFiltrados] = useState<EmpleadoMasterDto[]>([])
    const [contrasenas, setContrasenas] = useState<ControlContrasena[]>([])
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState<string>("")
    const [filtro, setFiltro] = useState("")

    const [showMsg, setShowMsg] = useState(false)
    const [msg, setMsg] = useState("")
    const [header, setHeader] = useState("")

    const [showModal, setShowModal] = useState(false)
    const [tipoContrasena, setTipoContrasena] = useState("")
    const [nuevaContrasena, setNuevaContrasena] = useState("")
    const [modoEditar, setModoEditar] = useState(false)

    const [mostrarPasswords, setMostrarPasswords] = useState<{ [key: number]: boolean }>({})


    // useEffect(() => {
    //     cargarMaster()
    // }, [])

    useEffect(() => {
    cargarMaster()
    cargarTiposContrasena()
}, [])


    const [refreshReporteKey, setRefreshReporteKey] = useState(0);

    const [tiposContrasena, setTiposContrasena] = useState<CatTipoContrasenaDto[]>([])
const [nuevoTipoContrasena, setNuevoTipoContrasena] = useState("")
const [editandoTipoId, setEditandoTipoId] = useState<number | null>(null)
const [nombreTipoEditando, setNombreTipoEditando] = useState("")


const cargarTiposContrasena = async () => {
    try {
        const response = await ControlContrasenasService.GetTiposContrasena(true)
        setTiposContrasena(response.data)
    } catch {
        mostrarMensaje("Error", "Error al cargar tipos de contraseña")
    }
}

const agregarTipoContrasena = async () => {
    const valor = nuevoTipoContrasena.trim()

    if (!valor) {
        mostrarMensaje("Advertencia", "Escriba un tipo de contraseña")
        return
    }

    try {
        await ControlContrasenasService.InsertarTipoContrasena({
            nombre: valor.toUpperCase()
        })

        setNuevoTipoContrasena("")
        setTipoContrasena("") // deja vacío el select
        await cargarTiposContrasena()

        mostrarMensaje("Éxito", "Tipo agregado correctamente")
    } catch {
        mostrarMensaje("Error", "Error al agregar tipo de contraseña")
    }
}



const desactivarTipoContrasena = async (id: number) => {
    try {
        await ControlContrasenasService.DesactivarTipoContrasena(id)
        mostrarMensaje("Éxito", "Tipo desactivado correctamente")
        await cargarTiposContrasena()
    } catch {
        mostrarMensaje("Error", "Error al desactivar tipo")
    }
}

const iniciarEditarTipo = (tipo: CatTipoContrasenaDto) => {
    setEditandoTipoId(tipo.id)
    setNombreTipoEditando(tipo.nombre)
}

const cancelarEditarTipo = () => {
    setEditandoTipoId(null)
    setNombreTipoEditando("")
}

const guardarEditarTipo = async () => {
    if (!editandoTipoId || !nombreTipoEditando.trim()) {
        mostrarMensaje("Advertencia", "Escriba el nombre del tipo")
        return
    }

    try {
        await ControlContrasenasService.ActualizarTipoContrasena(editandoTipoId, {
            nombre: nombreTipoEditando.trim().toUpperCase()
        })

        mostrarMensaje("Éxito", "Tipo actualizado correctamente")
        cancelarEditarTipo()
        await cargarTiposContrasena()
    } catch {
        mostrarMensaje("Error", "Error al actualizar tipo")
    }
}


const refrescarReporte = () => {
    setRefreshReporteKey(prev => prev + 1);
};

    useEffect(() => {
        cargarMaster()
        if(numEmpleadoInicial) {
            cargarDetalle(numEmpleadoInicial) // Carga las llaves del empleado seleccionado
        }
    }, [numEmpleadoInicial])


    
    const cargarMaster = async () => {
        try {
            const response = await ControlContrasenasService.GetEmpleadosMaster()
            setEmpleados(response.data)
            setEmpleadosFiltrados(response.data)
        } catch {
            mostrarMensaje("Error", "Error al cargar empleados")
        }
    }

    const cargarDetalle = async (numEmpleado: string) => {
        try {
            const response = await ControlContrasenasService.GetByEmpleado(numEmpleado)
            setContrasenas(response.data)
            setEmpleadoSeleccionado(numEmpleado)
        } catch {
            mostrarMensaje("Error", "Error al cargar contraseñas")
        }
    }

    const mostrarMensaje = (titulo: string, mensaje: string) => {
        setHeader(titulo)
        setMsg(mensaje)
        setShowMsg(true)
    }

    const filtrar = (e: any) => {
        const value = e.target.value
        setFiltro(value)

        const filtrados = empleados.filter(emp =>
            emp.numEmpleado.toLowerCase().includes(value.toLowerCase()) ||
            emp.name.toLowerCase().includes(value.toLowerCase())
        )

        setEmpleadosFiltrados(filtrados)
    }

    // const abrirModalInsert = () => {
    //     setModoEditar(false)
    //     setTipoContrasena("")
    //     setNuevaContrasena("")
    //     setShowModal(true)
    // }
    
    const abrirModalInsert = () => {
    setModoEditar(false)
    setTipoContrasena("")
    setNuevaContrasena("")
    setNuevoTipoContrasena("")
    setEditandoTipoId(null)
    setNombreTipoEditando("")
    setShowModal(true)
}
    
    const abrirModalEditar = (row: ControlContrasena) => {
        setModoEditar(true)
        setTipoContrasena(row.tipoContrasena)
        setNuevaContrasena("")
        setShowModal(true)
    }

    const guardarContrasena = async () => {

        // if (!tipoContrasena || !nuevaContrasena) {
        //     mostrarMensaje("Advertencia", "Complete todos los campos")
        //     return
        // }

                if (!tipoContrasena || !nuevaContrasena) {
            mostrarMensaje("Advertencia", "Complete todos los campos")
            return
        }

        const yaExiste = contrasenas.some(
            x => x.tipoContrasena.toLowerCase() === tipoContrasena.toLowerCase()
        )

        if (!modoEditar && yaExiste) {
            mostrarMensaje(
                "Advertencia",
                "Ese tipo de contraseña ya existe para este empleado. Use Editar si desea actualizarla."
            )
            return
        }



        const data: ActualizarContrasenaDto = {
            numEmpleado: empleadoSeleccionado,
            tipoContrasena: tipoContrasena,
            contrasena: nuevaContrasena
        }

        // try {
        //     await ControlContrasenasService.ActualizarContrasena(data)
        //     mostrarMensaje("Éxito", "Contraseña guardada correctamente")
        //     setShowModal(false)
        //     cargarDetalle(empleadoSeleccionado)
        //     await cargarMaster() 
        //     refrescarReporte();
        // } catch {
        //     mostrarMensaje("Error", "Error al guardar contraseña")
        // }

        try {
    await ControlContrasenasService.ActualizarContrasena(data)
    mostrarMensaje("Éxito", "Contraseña guardada correctamente")
    setShowModal(false)

    setTipoContrasena("")
    setNuevaContrasena("")
    setModoEditar(false)

    cargarDetalle(empleadoSeleccionado)
    await cargarMaster()
    refrescarReporte()
} catch {
    mostrarMensaje("Error", "Error al guardar contraseña")
}
    }

    const eliminarContrasena = async (row: ControlContrasena) => {
        if (!window.confirm("¿Seguro que deseas eliminar esta contraseña?")) return

        try {
            await ControlContrasenasService.EliminarContrasena(
                row.numEmpleado,
                row.tipoContrasena
            )
            mostrarMensaje("Eliminado", "Contraseña eliminada correctamente")
            cargarDetalle(row.numEmpleado)
            await cargarMaster() 
            refrescarReporte();
        } catch {
            mostrarMensaje("Error", "Error al eliminar contraseña")
        }
    }

    const toggleMostrarPassword = (id: number) => {
        setMostrarPasswords(prev => ({
            ...prev,
            [id]: !prev[id]
        }))
    }

    const columnasMaster = [
        {
            name: "NumEmpleado",
            selector: (row: EmpleadoMasterDto) => row.numEmpleado,
            sortable: true,
            width: "120px"
        },
        {
            name: "Nombre",
            selector: (row: EmpleadoMasterDto) => row.name,
            sortable: true,
            wrap: true
        },
        {
            name: "Departamento",
            selector: (row: EmpleadoMasterDto) => row.departamento,
            sortable: true
        },
         {
               name: 'Estado',
               width: '90px',
               cell: (row: EmpleadoMasterDto) => (
                 <Badge bg={row.activo ? 'success' : 'danger'}>
                   {row.activo ? 'Activo' : 'Baja'}
                 </Badge>
               ),
             },
        {
    name: "Tiene Contraseñas",
    selector: (row: EmpleadoMasterDto) => row.tieneContrasenas ? "SI" : "NO",
    sortable: true,
    cell: (row: EmpleadoMasterDto) => (
        <span className={row.tieneContrasenas ? "badge bg-success" : "badge bg-secondary"}>
            {row.tieneContrasenas ? "SI" : "NO"}
        </span>
    )
}
        
    ]

    const columnasDetalle = [
        {
            name: "Tipo",
            selector: (row: ControlContrasena) => row.tipoContrasena,
            sortable: true
        },
        {
            name: "Contraseña",
            cell: (row: ControlContrasena) => (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span>
                        {mostrarPasswords[row.id]
                            ? row.contrasenaPlana
                            : "••••••••"}
                    </span>
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => toggleMostrarPassword(row.id)}
                    >
                        👁
                    </Button>
                </div>
            )
        },
        {
            name: "FechaActualizacion",
            selector: (row: ControlContrasena) =>
            (row.fechaUltimaActualizacion), 
            width: "180px"
        },
        {
            name: "Vencimiento",
            selector: (row: ControlContrasena) =>(row.fechaVencimiento), 
            width: "180px"
        },
        {
            name: "Estatus",
            cell: (row: ControlContrasena) => (
                <span className={
                    row.estatus === "AL DIA"
                        ? "badge bg-success"
                        : row.estatus === "POR VENCER"
                        ? "badge bg-warning"
                        : "badge bg-danger"
                }>
                    {row.estatus}
                </span>
            )
        },
        {
            name: "FechaRegistro",
            selector: (row: ControlContrasena) =>
                (row.fechaRegistroSistema)
           
        },
        {
            name: "Acciones",
            cell: (row: ControlContrasena) => (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button
                        size="sm"
                        variant="primary"
                        onClick={() => abrirModalEditar(row)}
                    >
                        Editar
                    </Button>

                    <Button
                        size="sm"
                        variant="danger"
                        onClick={() => eliminarContrasena(row)}
                    >
                        Eliminar
                    </Button>
                </div>
            )
        }
    ]

    return (
        <div className="container-fluid mt-3">

            <Row>
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <h5>Empleados</h5>

                            <Form.Control
                                type="text"
                                placeholder="Buscar..."
                                value={filtro}
                                onChange={filtrar}
                                className="mb-3"
                            />

                            <DataTable
                                columns={columnasMaster}
                                data={empleadosFiltrados}
                                onRowClicked={(row: any) => cargarDetalle(row.numEmpleado)}
                                highlightOnHover
                                pointerOnHover
                                pagination
                                dense
                            />
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h5>
                                    Contraseñas {empleadoSeleccionado && `- ${empleadoSeleccionado}`}
                                </h5>

                                {empleadoSeleccionado && (
                                    <Button size="sm" variant="success" onClick={abrirModalInsert}>
                                        + Nueva
                                    </Button>
                                )}
                            </div>

                            <DataTable
                                columns={columnasDetalle}
                                data={contrasenas}
                                pagination
                                highlightOnHover
                                dense
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* MODAL */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modoEditar ? "Actualizar Contraseña" : "Nueva Contraseña"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group className="mb-3">
                        {/* <Form.Label>Tipo Contraseña</Form.Label>
                        <Form.Control
                            type="text"
                            value={tipoContrasena}
                            onChange={(e) => setTipoContrasena(e.target.value)}
                            disabled={modoEditar}
                        /> */}

                        <Row className="align-items-end">
    <Col md={8}>
        <Form.Label>Tipo de contraseña</Form.Label>

        <Form.Select
            value={tipoContrasena}
            onChange={(e) => setTipoContrasena(e.target.value)}
            disabled={modoEditar}
            autoComplete="off"
            
        >
            <option value="">Seleccione tipo</option>

            {tiposContrasena.map((tipo) => (
                <option key={tipo.id} value={tipo.nombre}>
                    {tipo.nombre}
                </option>
            ))}
        </Form.Select>
    </Col>

    {!modoEditar && (
        <Col md={4}>
            <Form.Label>Opciones</Form.Label>

            <div className="d-flex gap-1">
                <Button
                    size="sm"
                    variant="warning"
                    disabled={!tipoContrasena}
                    onClick={() => {
                        const tipo = tiposContrasena.find(x => x.nombre === tipoContrasena)

                        if (tipo) {
                            iniciarEditarTipo(tipo)
                        }
                    }}
                >
                    Editar
                </Button>

                <Button
                    size="sm"
                    variant="danger"
                    disabled={!tipoContrasena}
                    onClick={() => {
                        const tipo = tiposContrasena.find(x => x.nombre === tipoContrasena)

                        if (tipo) {
                            desactivarTipoContrasena(tipo.id)
                        }
                    }}
                >
                    Quitar
                </Button>
            </div>
        </Col>
    )}
</Row>

{!modoEditar && (
    <div className="d-flex gap-2 mt-2">
        <Form.Control
            size="sm"
            type="text"
            placeholder={editandoTipoId ? "Editar tipo" : "Nuevo tipo"}
            value={editandoTipoId ? nombreTipoEditando : nuevoTipoContrasena}
            onChange={(e) => {
                const valor = e.target.value.toUpperCase()

                if (editandoTipoId) {
                    setNombreTipoEditando(valor)
                } else {
                    setNuevoTipoContrasena(valor)
                }
            }}
        />

        {editandoTipoId ? (
            <>
                <Button
                    size="sm"
                    variant="success"
                    onClick={guardarEditarTipo}
                >
                    Guardar
                </Button>

                <Button
                    size="sm"
                    variant="secondary"
                    onClick={cancelarEditarTipo}
                >
                    Cancelar
                </Button>
            </>
        ) : (
            <Button
                size="sm"
                variant="secondary"
                onClick={agregarTipoContrasena}
            >
                Agregar
            </Button>
        )}
    </div>
)}

               













                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Contraseña</Form.Label>
                        {/* <Form.Control
                            type="password"
                            value={nuevaContrasena}
                            onChange={(e) => setNuevaContrasena(e.target.value)}
                        /> */}

                        <Form.Control
                            type="password"
                            value={nuevaContrasena}
                            onChange={(e) => setNuevaContrasena(e.target.value)}
                            autoComplete="new-password"
                            name="nuevaContrasenaControl"
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={guardarContrasena}>
                        Guardar
                    </Button>
                </Modal.Footer>

                                




            </Modal>


            

            {/* <ReporteControlContrasenas refreshKey={refreshReporteKey} /> */}

            <ReporteControlContrasenas
    refreshKey={refreshReporteKey}
    onSeleccionarEmpleado={(numEmpleado) => {
        setFiltro(numEmpleado)
        setEmpleadosFiltrados(
            empleados.filter(emp => emp.numEmpleado === numEmpleado)
        )
        cargarDetalle(numEmpleado)
    }}
/>
            <MsgInformativo
                show={showMsg}
                msg={msg}
                header={header}
                msgColor="primary"
                closeToast={() => setShowMsg(false)}
            />
        </div>
    )
}

export default ControlContrasenas
